import type { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router-dom";

import DiseasesCell from "@/components/table/patients/diseases-cell";
import RiskFactorCell from "@/components/table/patients/risk-factor-cell";
import ArrowNarrowRight from "@/icons/Solid/arrow-narrow-right";
import { getConsultationStepLabel } from "@/types/api/consultation";
import type { Patient } from "@/types/api/patient";
import { getDiseases, getName, getRiskFactors } from "@/utils/patient";

export const columns: Array<ColumnDef<Patient>> = [
  {
    header: "Nom du patient",
    accessorFn: (row) => getName(row),
    id: "name",
    meta: {
      filterVariant: "text",
    },
  },
  {
    accessorFn: (row) => getDiseases(row),
    header: "Maladie(s)",
    id: "diseases",
    cell: ({ row }) => <DiseasesCell patient={row.original} />,
    meta: {
      filterVariant: "text",
    },
  },
  {
    accessorFn: (row) => getRiskFactors(row),
    header: "Facteurs de risque",
    id: "riskFactors",
    cell: ({ row }) => <RiskFactorCell patient={row.original} />,
    meta: {
      filterVariant: "text",
    },
  },
  {
    accessorFn: (row) =>
      row.consultations.length > 0
        ? getConsultationStepLabel(
            row.consultations[row.consultations.length - 1].consultationStep
          )
        : "",
    header: "Traitement en cours",
    id: "treatment",
  },
  {
    accessorFn: () => "",
    cell: ({ row }) => (
      <Link to={`/patients/${row.original.id}`}>
        <ArrowNarrowRight />
      </Link>
    ),
    id: " ",
  },
];
